import History from './component';
import { HistoryProps } from './types';

export default History;
export type { HistoryProps };
